import InfoPage from '@/components/InfoPage';
import Layout from '../components/Layout';
import API from '../api';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import {getServerSidePaths} from "@/pages/contacts/[slug]";

// Заглушка для переводов
const translate = s => s;

const PrivacyPage = ({ data = {} }) => {
  return <InfoPage data={data} />;
};

const breadcrumbs = [
  { title: translate('Главная'), route: '/' },
  { title: translate('Политика конфиденциальности'), route: '/privacy-policy' },
];

PrivacyPage.getLayout = (page, t) => {
  const title = page.pageProps?.data?.title
    ? page.pageProps.data.title
    : t('Политика конфиденциальности');
  return (
    <Layout page={page.props} breadcrumbs={breadcrumbs} title={`${title} — UNIFROST`}>
      {page}
    </Layout>
  );
};

export async function getServerSideProps(context) {
  const props = { data: {} };

  try {
    const res = await API.get(`/v1/api/pages/privacy-policy/`, {
      headers: { 'Accept-Language': context.locale },
    });

    if (res.status === 200) {
      if (res.data) props.data = res.data;
    }
  } catch (error) {}

  return {
    props: {
      ...props,
      ...(await serverSideTranslations(context.locale, ['common', 'menu'])),
    },
    // revalidate: 60,
  };
}

export default PrivacyPage;
